export default __webpack_public_path__ + "static/media/eproVinR.70b6029a.png";